import React from "react";
import {
  Users,
  CheckCircle,
  XCircle,
  FileSearch,
  SealCheck,
  ArrowUUpLeft,
  WarningCircle,
} from "@phosphor-icons/react";
import { Loader2 } from "lucide-react";

export default function DetailedApplicationSummary({ dashboardData, isLoading, isError }) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center w-full h-24 mb-6">
        <Loader2 className="w-6 h-6 text-emerald-700 animate-spin" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="w-full p-3 mb-6 text-sm text-center text-red-500 bg-red-50 rounded-lg border border-red-100">
        Unable to load pipeline data.
      </div>
    );
  }

  const data = dashboardData?.detailedPipeline;

  const stats = [
    {
      label: "Total",
      value: data?.totalApplication || 0,
      icon: Users,
      weight: "duotone",
    },
    {
      label: "Submitted",
      value: data?.counts?.REVIEW || 0,
      icon: FileSearch,
      weight: "duotone",
    },
    {
      label: "Verified",
      value: data?.counts?.VERIFIED || 0,
      icon: SealCheck,
      weight: "fill",
    },
    {
      label: "Approved",
      value: data?.counts?.APPROVED || 0,
      icon: CheckCircle,
      weight: "fill",
    },
    {
      label: "Accepted",
      value: data?.counts?.ACCEPTED || 0,
      icon: CheckCircle,
      weight: "fill",
    },
    {
      label: "Returned",
      value: data?.counts?.RETURNED || 0,
      icon: ArrowUUpLeft,
      weight: "regular",
    },
    {
      label: "Rejected",
      value: data?.counts?.REJECTED || 0,
      icon: XCircle,
      weight: "regular",
    },
    {
      label: "Invalid",
      value: data?.counts?.INVALIDATED || 0,
      icon: WarningCircle,
      weight: "regular",
    },
  ];

  return (
    <div className="w-full mb-6 mt-5">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xs font-bold text-slate-500 uppercase tracking-widest ml-1">
          Application Summary
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center p-3 rounded-lg border-3 border-white bg-slate-50 shadow-sm cursor-default select-none h-24"
          >
            <div className="h-7 w-7 rounded-md flex items-center justify-center mb-2 text-emerald-400 ">
              <stat.icon size={18} weight={stat.weight} />
            </div>
            <h3 className="text-lg font-bold text-slate-700 leading-none">
              {stat.value}
            </h3>
            <p className="text-[10px] font-semibold text-slate-600 uppercase tracking-wide mt-1.5">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
